<template>
<div class="notAccess-container">
  <main>
    <div class="not-access">
      <div class="not-access-box">
        <div>접근 할 수 없습니다.</div>
        <div>사내 내부망을 통해 접속해주세요.</div>
      </div>
    </div>
  </main>
</div>
</template>

<script>
    export default {
      name: 'NotAccess',
      data () {
        return {}
      },
      computed: {},
      mounted () {
      },
      watch: {},
      methods: {},
      components: {}
    }

</script>

<style scoped>
  @import "NotAccess.scss";
</style>